import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import ProductList from './ProductList';
import Address from './Address';
import FullName from './FullName';
import Phone from './Phone';
import Email from './Email';

const FoodOnlineOrderForm = () => {


    const productList = [
        {
            id: Math.floor(Math.random() * 1000) + 100,
            name: 'نام محصولات',
            description: 'توضیحات را وارد کنید',
            image: null,
            price: '10000',
            quantity: 1,
        },
        {
            id: Math.floor(Math.random() * 1000) + 100,
            name: 'نام محصولات',
            description: 'توضیحات را وارد کنید',
            image: null,
            price: '10000',
            quantity: 1,
        },
        {
            id: Math.floor(Math.random() * 1000) + 100,
            name: 'نام محصولات',
            description: 'توضیحات را وارد کنید',
            image: null,
            price: '10000',
            quantity: 1,
        },
        {
            id: Math.floor(Math.random() * 1000) + 100,
            name: 'نام محصولات',
            description: 'توضیحات را وارد کنید',
            image: null,
            price: '10000',
            quantity: 1,
        },
    ]


    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'سفارش غذا'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <ProductList header={'اقلام قابل تحویل'} product={productList} />
                <Address header={'آدرس صورتحساب'}/>
                <Heading header={'جزئیات تحویل'}/>
                <FullName header={'نام و نام خانوادگی'}/>
                <Address header={'آدرس'}/>
                <Phone header={'شماره تلفن'}/>
                <Email header={'ایمیل'}/>
                <Heading header={'جزئیات پرداخت'}/>
                <FullName header={'نام و نام خانوادگی'}/>
                <Phone header={'شماره تلفن'}/>
                <Email header={'ایمیل'}/>
            </Grid>
        </Grid>
    )
}

export default FoodOnlineOrderForm
